import { useEffect, useState } from 'react'
import constants from 'common/helpers/constants'
import useFeatures from './useFeatures'


// TODO use this hook only inside applePay button, to not rerender all jsx in the component where it used
const useApplePaySupported = (): boolean => {
  const [ isSupported, setSupportStatus ] = useState(false)
  const { [constants.features.applePay]: isApplePayEnabled } = useFeatures()

  useEffect(() => {
    if (isApplePayEnabled && window.ApplePaySession) {
      window.ApplePaySession.canMakePaymentsWithActiveCard('merchant.com.scentbird')
        .then((canMakePayments) => {
          if (canMakePayments) {
            setSupportStatus(true)
          }
        })
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return isSupported
}


export default useApplePaySupported
